import {
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TableRow,
    TextField
} from '@material-ui/core';
import { MODAL_TYPE, useModals } from '../../hooks/useModal';
import { DeleteIcon, PlusIcon } from '../../icons';
import React from 'react';

export default function GlcodeEditor({ value, setValue }) {
    const [newSection, setNewSection] = React.useState('');
    const [newValue2, setNewValue] = React.useState('');
    const { showModal } = useModals();
    // value is the full object here, each part is just one of the sections
    const glCompatibleValues = value || {};
    return (
        <Table fullWidth>
            <TableHead>
                <TableCell>Code section</TableCell>
                <TableCell></TableCell>
            </TableHead>
            <TableBody>
                {Object.entries(glCompatibleValues).map(([label, v]) => {
                    return (
                        <TableRow key={label}>
                            <TableCell>
                                <TextField
                                    label={label}
                                    fullWidth
                                    type="text"
                                    value={v}
                                    onChange={ev =>
                                        setValue({
                                            ...glCompatibleValues,
                                            [label]: ev.target.value
                                        })
                                    }
                                />
                            </TableCell>
                            <TableCell style={{ width: 10 }}>
                                <IconButton
                                    onClick={() => {
                                        showModal(MODAL_TYPE.CONFIRMATION, {
                                            title: `Are you sure you want to remove ${label}?`,
                                            content: 'This action is irreversible.',
                                            confirm: () => {
                                                const newValue = { ...glCompatibleValues };
                                                delete newValue[label];
                                                setValue(newValue);
                                            }
                                        });
                                    }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
            <TableFooter>
                <TableCell>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                label="New code section"
                                fullWidth
                                size="small"
                                type="text"
                                value={newSection}
                                onChange={ev => setNewSection(ev.target.value)}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="New value"
                                fullWidth
                                size="small"
                                type="text"
                                value={newValue2}
                                onChange={ev => setNewValue(ev.target.value)}
                            />
                        </Grid>
                    </Grid>
                </TableCell>
                <TableCell style={{ width: 10 }}>
                    <IconButton
                        onClick={() => {
                            // if the new section is empty, do nothing
                            if (!newSection) {
                                return;
                            }

                            const newValue = { ...glCompatibleValues };
                            newValue[newSection] = newValue2;
                            setValue(newValue);

                            //reset the new section input
                            setNewSection('');
                            setNewValue('');
                        }}
                    >
                        <PlusIcon />
                    </IconButton>
                </TableCell>
            </TableFooter>
        </Table>
    );
}
